import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../../utils/api';
import GeneralVision from '../Settings/GeneralVision';
import Billing from '../Settings/Billing';
import Services from '../Settings/Services';
import Credits from '../Settings/Credits';
import Security from '../Settings/Security';
import Settings from '../Settings/Settings';

import { FiHome, FiCreditCard, FiBox, FiLock, FiSettings, FiDollarSign, FiMenu } from 'react-icons/fi';

const EditUserViewPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('general');
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    api.get(`/api/users/${id}`).then((res) => {
      setUser(res.data);
      setFormData(res.data);
      setLoading(false);
    });
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    try {
      await api.put(`/api/users/${id}`, formData);
      alert('Cambios guardados correctamente');
    } catch (err) {
      console.error('Error al guardar los cambios:', err);
      alert('Error al guardar los cambios');
    }
  };

  if (loading) return <p className="p-8 text-center">Cargando...</p>;
  if (!user) return <p className="p-8 text-center text-red-600">Usuario no encontrado</p>;

  const menuItems = [
    { icon: <FiHome />, label: 'Vista General', key: 'general' },
    { icon: <FiCreditCard />, label: 'Facturación', key: 'facturacion' },
    { icon: <FiBox />, label: 'Servicios', key: 'servicios' },
    { icon: <FiDollarSign />, label: 'Créditos', key: 'creditos' },
    { icon: <FiLock />, label: 'Seguridad', key: 'seguridad' },
    { icon: <FiSettings />, label: 'Configuración', key: 'configuracion' },
  ];

  return (
    <div className="bg-[oklch(97%_0.014_254.604)] min-h-screen font-[Manrope]">
      <div className="max-w-6xl mx-auto bg-white shadow border rounded-xl lg:flex overflow-hidden">
        {/* Sidebar */}
        <aside
          className={`w-full lg:w-64 border-r px-6 py-6 space-y-6 lg:relative z-50 bg-white fixed lg:static top-0 left-0 h-screen lg:h-auto transform transition-transform duration-300 ease-in-out ${menuOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0`}
        >
          <div className="flex justify-between items-center lg:hidden">
            <h2 className="text-lg font-bold">Menú</h2>
            <button onClick={() => setMenuOpen(false)} className="text-gray-500">✕</button>
          </div>

          <div className="text-center space-y-2">
            <div className="mx-auto h-16 w-16 flex items-center justify-center rounded-full bg-gray-200 text-blue-800 font-bold text-lg">
              {user.first_name.charAt(0)}{user.last_name.charAt(0)}
            </div>
            <h2 className="text-sm font-semibold text-gray-900">{user.first_name} {user.last_name}</h2>
            <p className="text-sm text-gray-500">{user.email}</p>
          </div>

          <div className="text-sm text-gray-600 space-y-1 border-t pt-4 mt-4">
            <p><strong>Registrado:</strong> {new Date(user.created_at).toLocaleDateString()}</p>
            <p><strong>Último acceso:</strong> —</p>
          </div>

          <div className="text-sm">
            <p className="uppercase font-medium text-xs text-gray-400 mb-2 mt-6">Menú del usuario</p>
            <nav className="space-y-2">
              {menuItems.map(({ icon, label, key }) => (
                <button
                  key={key}
                  onClick={() => {
                    setActiveTab(key);
                    setMenuOpen(false);
                  }}
                  className={`flex items-center gap-2 w-full text-left text-sm px-2 py-1.5 rounded-md transition ${
                    activeTab === key
                      ? 'bg-[oklch(93.2%_0.032_255.585)] text-blue-800 font-semibold'
                      : 'text-gray-700 hover:text-blue-800 hover:bg-gray-50'
                  }`}
                >
                  {icon}
                  {label}
                </button>
              ))}
            </nav>
          </div>
        </aside>

        {/* Main content */}
        <main className="flex-1 p-6 relative flex flex-col">
          {/* Toggle para móvil */}
          <div className="lg:hidden mb-4">
            <button
              onClick={() => setMenuOpen(true)}
              className="inline-flex items-center gap-2 text-sm text-gray-700 hover:text-blue-800"
            >
              <FiMenu className="w-5 h-5" /> Menú del usuario
            </button>
          </div>

          <div className="max-w-3xl space-y-10">
            {activeTab === 'general' && (
              <GeneralVision formData={formData} handleChange={handleChange} handleSave={handleSave} />
            )}
            {activeTab === 'facturacion' && <Billing userId={user.id} />}
            {activeTab === 'servicios' && <Services userId={user.id} />}
            {activeTab === 'creditos' && <Credits  user={user} />}
            {activeTab === 'seguridad' && <Security user={user} />}
            {activeTab === 'configuracion' && <Settings user={user} />}
          </div>

          <div className="flex justify-end items-center mt-12 pt-4 border-t bg-white sticky bottom-0">
            <button
              onClick={() => navigate('/clientes')}
              className="px-4 py-2 border border-gray-300 rounded text-gray-700 hover:bg-gray-100"
            >
              Salir
            </button>
          </div>
        </main>
      </div>
    </div>
  );
};

export default EditUserViewPage;
